import { Box, Container } from "@mui/material";
import Link from "next/link";
import CustomMetas from "../components/custom-metas/customMetas";
import useTranslation from "../hooks/useTranslation";
import cssVars from '../styles/vars.module.scss'

const ServerError = () => {

    const { t } = useTranslation()

    return (
        <Container maxWidth="xl" sx={{ textAlign: "center", mt: { xs: 3, lg: 5 } }}>
            <CustomMetas title={"500 Internal server error"}
                description={"500 Internal server error"}
                keywords={"500 Internal server error"}
                page_type="product.item"
            />
            <Box fontSize={{ xs: "80px", md: "100px" }} fontWeight={600}>500</Box>
            <Box component="h3" mb={4}>{t("Internal server error")}</Box>
            <Link href="/">
                <Box height={40} fontWeight={500} px={3} component="span" sx={{ py: "12px", px: "30px", borderRadius: '25px', bgcolor: cssVars.white, border: `1px solid ${cssVars.black}`, color: cssVars.black, ":hover": { bgcolor: cssVars.black, borderColor: cssVars.black, color: cssVars.white } }}>
                    {t("Return to home page")}
                </Box>
            </Link>
        </Container >
    )
}

export default ServerError;